import { createContext, useContext, useState, useEffect } from 'react';

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem('keiks_cart') || '[]'); }
    catch { return []; }
  });

  useEffect(() => {
    localStorage.setItem('keiks_cart', JSON.stringify(items));
  }, [items]);

  const addItem = (product, customization) => {
    const cartItem = {
      cartId: Date.now().toString(),
      productId: product.id,
      product: product,
      delivery_methods: product.delivery_methods || ['pickup', 'delivery'],
      name: product.name,
      image: product.image,
      size: customization.size,
      filling: customization.filling,
      flavor: customization.flavor,
      complements: customization.complements || [],
      observations: customization.observations || '',
      subtotal: customization.totalPrice,
      quantity: 1,
    };
    setItems(prev => [...prev, cartItem]);
  };

  const removeItem = (cartId) => {
    setItems(prev => prev.filter(item => item.cartId !== cartId));
  };

  const clearCart = () => setItems([]);

  const total = items.reduce((sum, item) => sum + item.subtotal, 0);
  const itemCount = items.length;

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, clearCart, total, itemCount }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
